var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-view"},[_c('h1',[_vm._v("Dental Clinic")]),_c('p',[_vm._v("Fecha: "+_vm._s(_vm.currentDate))]),_c('p',[_vm._v("App Version: "+_vm._s(_vm.appVersion))])])}
var staticRenderFns = []

export { render, staticRenderFns }